/*
 * RG label filters
 * Collection page filters (desktop sidebar and phone drawer). See notes-label-filters.md.
 * Every list filter: shows up to 10 choices, most products first, the rest behind "Show more (N)" (3 Nov 2026).
 * A list filter with one choice left (nothing ticked) is hidden. Type, Print size, Set show only for one kind of product.
 * Occasion: the next 3 festivals first, with a "Coming up" tag. For whom: groups (Parents ...) count as one choice.
 * Sections open and close with an arrow: the first 3 visible are open. Choices are a list with tick boxes (look is in the CSS).
 * Desktop: a "Filter by" title with a "Clear all" box on top. Product filter with more than 10 choices: a search box.
 * Phone: the drawer button says "Show N products".
 * On its own page a filter is hidden: no Occasion filter on an occasion page, no For whom filter on a
 * for-whom page (Ryan, 2 Nov 2026). Other collection pages keep every filter.
 * Reads the shared data from <script id="rg-gift-data"> (snippets/rg-gift-data.liquid).
 * Does not change any theme file.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root || root.hasAttribute('data-rg-lf')) { return; }
  root.setAttribute('data-rg-lf', 'on');

  var TIDY = 'data-rg-tidy';
  var OFF = 'rg-lf-off';
  var TOP = 10;         /* choices shown before "Show more" (pinned festivals included) */
  var SEARCH_FROM = 11; /* Product filter: a search box from this many choices */
  var OPEN_FIRST = 3;   /* the first 3 visible sections start open */
  var FORMS = '.filters-form:not(.horizontal-filter-form)';
  var KEYS = ['occasion', 'for_whom', 'style', 'product'];
  /* Filters whose values belong to one kind of product (Ryan, 2 Nov 2026): A4/A3 for T-shirts,
     Small/Large for blankets, V/Normal for scrolls. Shown only when the page holds one kind of
     product, or the shopper picked one kind in the Product filter. Can be set in the data as kind_filters. */
  var DEFAULT_KIND = ['filter.p.m.custom.product_type', 'filter.p.m.custom.print_size', 'filter.p.m.custom.set'];
  var DEFAULT_PARAMS = {
    occasion: 'filter.p.m.rg_filter.occasion',
    for_whom: 'filter.p.m.rg_filter.for_whom',
    style: 'filter.p.m.rg_filter.style',
    product: 'filter.p.m.rg_filter.product'
  };
  var ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;
  var CHEVRON =
    '<svg viewBox="0 0 14 8" width="12" height="8" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Open / closed memory (sections, groups, "Show more"). It survives the theme re-rendering a filter. */
  var memory = {};
  var groupOf = new WeakMap();   /* group checkbox -> group record */
  var toggleOf = new WeakMap();  /* chevron button -> group record */
  var groupsOf = new WeakMap();  /* list -> array of group records */
  var viewOf = new WeakMap();    /* list -> view (units, "Show more" state) */

  var cfg = readConfig();
  if (!cfg) {
    root.setAttribute('data-rg-lf', 'off');
    return;
  }

  /* ---------- data ---------- */

  function strings(a) {
    var out = [];
    if (Array.isArray(a)) {
      a.forEach(function (s) { if (typeof s === 'string' && s) { out.push(s); } });
    }
    return out;
  }

  function groups(a) {
    var out = [];
    if (Array.isArray(a)) {
      a.forEach(function (g) {
        if (g && typeof g.name === 'string' && Array.isArray(g.values)) {
          var v = strings(g.values);
          if (v.length) { out.push({ name: g.name, values: v }); }
        }
      });
    }
    return out;
  }

  /* The page's handle: /collections/<handle> (also with a language prefix). '' when not a collection page. */
  function pageHandle() {
    var m = /\/collections\/([^\/?#]+)/.exec(location.pathname || '');
    if (!m) { return ''; }
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  /* true when the handle is one of the values of a { label: handle } list in the data. */
  function isPageIn(list, handle) {
    if (!handle || !list || typeof list !== 'object') { return false; }
    return Object.keys(list).some(function (k) {
      return typeof list[k] === 'string' && list[k].toLowerCase() === handle;
    });
  }

  function readConfig() {
    var el = document.getElementById('rg-gift-data');
    if (!el) { return null; }
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!d || typeof d !== 'object') { return null; }
    var p = d.filter_params && typeof d.filter_params === 'object' ? d.filter_params : {};
    var nameToKey = {};
    KEYS.forEach(function (k) {
      var n = typeof p[k] === 'string' && p[k] ? p[k] : DEFAULT_PARAMS[k];
      nameToKey[n] = k;
    });
    var festivals = Array.isArray(d.festivals) ? d.festivals : [];
    var festivalKeys = {};
    festivals.forEach(function (f) {
      if (f && typeof f.label === 'string') { festivalKeys[norm(f.label)] = true; }
    });
    /* The filter that has nothing to choose on this page (its own page type). */
    var here = pageHandle();
    var hideHere = '';
    if (isPageIn(d.occasion_pages, here)) {
      hideHere = typeof p.occasion === 'string' && p.occasion ? p.occasion : DEFAULT_PARAMS.occasion;
    } else if (isPageIn(d.for_whom_pages, here)) {
      hideHere = typeof p.for_whom === 'string' && p.for_whom ? p.for_whom : DEFAULT_PARAMS.for_whom;
    }
    return {
      hideHere: hideHere,
      festivals: festivals,
      festivalKeys: festivalKeys,
      forWhom: groups(d.for_whom_groups),
      style: strings(d.style_order),
      nameToKey: nameToKey,
      productParam: typeof p.product === 'string' && p.product ? p.product : DEFAULT_PARAMS.product,
      kindParams: strings(d.kind_filters).length ? strings(d.kind_filters) : DEFAULT_KIND
    };
  }

  /* Compare labels without caring about case, curly quotes, dashes or spaces. */
  function norm(s) {
    return String(s)
      .replace(/[\u2018\u2019\u02BC]/g, "'")
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* Today in India (Asia/Kolkata, UTC+5:30, no daylight saving), as YYYY-MM-DD. */
  function todayIndia() {
    return new Date(new Date().getTime() + 19800000).toISOString().slice(0, 10);
  }

  /* The first 3 festivals (in list order) whose last day is today or later. */
  function nextFestivals() {
    var today = todayIndia();
    var out = [];
    var seen = {};
    for (var i = 0; i < cfg.festivals.length && out.length < 3; i++) {
      var f = cfg.festivals[i];
      if (!f || typeof f.label !== 'string') { continue; }
      var end = '';
      if (typeof f.until === 'string' && ISO_DAY.test(f.until)) { end = f.until; }
      else if (typeof f.date === 'string' && ISO_DAY.test(f.date)) { end = f.date; }
      if (!end || end < today) { continue; }
      var k = norm(f.label);
      if (seen[k]) { continue; }
      seen[k] = true;
      out.push(f.label);
    }
    return out;
  }

  function quote(n) { return '"' + n.replace(/(["\\])/g, '\\$1') + '"'; }

  function layoutOf(el) { return el.closest('#FacetFiltersFormDrawer') ? 'drawer' : 'side'; }

  /* ---------- reading a list ---------- */

  function readCount(li) {
    var span = li.querySelector('.count');
    var m = span ? /\d[\d,]*/.exec(span.textContent) : null;
    return m ? parseInt(m[0].replace(/,/g, ''), 10) : NaN;
  }

  function readList(list) {
    var ctx = { list: list, items: [], byKey: {} };
    for (var i = 0; i < list.children.length; i++) {
      var li = list.children[i];
      if (li.tagName !== 'LI') { continue; }
      var input = li.querySelector('input[type="checkbox"]');
      if (!input) { continue; }
      /* The theme hides item 7 and later with these classes. We control it now. */
      li.classList.remove('hidden', 'hidden-load-more');
      var k = norm(input.value);
      var dup = !!ctx.byKey[k];
      var item = {
        li: li,
        input: input,
        k: k,
        count: readCount(li),
        /* No products here (the theme greys it out): not a choice. A copy of a value is not a choice either. */
        dead: dup || (input.disabled && !input.checked)
      };
      ctx.items.push(item);
      if (!dup) { ctx.byKey[k] = item; }
    }
    return ctx;
  }

  /* ---------- units: one choice = one chip (a For whom group is one unit) ---------- */

  function plainUnit(it, order) {
    return {
      els: [it.li],
      inputs: [it.input],
      text: it.k,
      count: it.count,
      avail: !it.dead,
      pinned: false,
      late: false,
      order: order,
      rank: Infinity
    };
  }

  function byCount(a, b) {
    var ca = isNaN(a.count) ? -1 : a.count;
    var cb = isNaN(b.count) ? -1 : b.count;
    return (cb - ca) || (a.order - b.order);
  }

  /* Returns the units in display order and sets unit.rank (0 = most products). */
  function rank(units) {
    var avail = units.filter(function (u) { return u.avail; });
    var dead = units.filter(function (u) { return !u.avail; });
    var pinned = avail.filter(function (u) { return u.pinned; }).sort(function (a, b) { return a.pin - b.pin; });
    var normal = avail.filter(function (u) { return !u.pinned && !u.late; }).sort(byCount);
    var late = avail.filter(function (u) { return !u.pinned && u.late; }).sort(byCount);
    pinned.forEach(function (u) { u.rank = -1; });
    normal.forEach(function (u, i) { u.rank = pinned.length + i; });   /* pinned ones count towards TOP */
    late.forEach(function (u) { u.rank = Infinity; });
    dead.forEach(function (u) { u.rank = Infinity; });
    return pinned.concat(normal, late, dead);
  }

  function place(list, ordered) {
    var frag = document.createDocumentFragment();
    ordered.forEach(function (u) { u.els.forEach(function (el) { frag.appendChild(el); }); });
    list.appendChild(frag);
  }

  function plainUnits(ctx, styleOrder) {
    var pos = {};
    if (styleOrder) { styleOrder.forEach(function (l, i) { if (pos[norm(l)] === undefined) { pos[norm(l)] = i; } }); }
    return ctx.items.map(function (it, i) {
      return plainUnit(it, styleOrder && pos[it.k] !== undefined ? pos[it.k] : (styleOrder ? 1000 + i : i));
    });
  }

  /* Occasion: the next 3 festivals that are on this page come first ("Coming up"). Festivals that are
     not in the next 3 never take one of the top 5 places: they wait behind "Show more". */
  function occasionUnits(ctx) {
    var pin = {};
    nextFestivals().forEach(function (l, i) { pin[norm(l)] = i; });
    return ctx.items.map(function (it, i) {
      var u = plainUnit(it, i);
      if (u.avail && pin[it.k] !== undefined) {
        u.pinned = true;
        u.pin = pin[it.k];
        u.tag = true;
      } else if (cfg.festivalKeys[it.k]) {
        u.late = true;
      }
      return u;
    });
  }

  function addTag(li) {
    if (li.querySelector('.rg-lf-tag')) { return; }
    var tag = document.createElement('span');
    tag.className = 'rg-lf-tag';
    tag.textContent = 'Coming up';
    li.appendChild(tag);
  }

  /* ---------- For whom groups ---------- */

  function setLabelText(label, text) {
    var nodes = label.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].nodeType === 3 && nodes[i].nodeValue.trim()) {
        /* Keep the spaces around the old text, so the count keeps its gap. */
        var old = nodes[i].nodeValue;
        nodes[i].nodeValue = old.replace(old.trim(), text);
        return;
      }
    }
    label.insertBefore(document.createTextNode(text), label.firstChild);
  }

  function buildGroup(ctx, name, present, n) {
    var id = 'rg-lf-' + ctx.layout + '-' + ctx.key + '-' + n;
    var tpl = present[0].li;
    var li = tpl.cloneNode(true);
    li.classList.remove('hidden', 'hidden-load-more', 'last-0', 'facet-checkbox--disabled', OFF);
    li.classList.add('rg-lf-group');
    li.removeAttribute('id');

    var input = li.querySelector('input[type="checkbox"]');
    ['name', 'value', 'checked', 'disabled'].forEach(function (a) { input.removeAttribute(a); });
    input.checked = false;
    input.id = id;
    input.classList.add('rg-lf-group-input');

    var label = li.querySelector('label');
    label.setAttribute('for', id);
    label.classList.remove('disabled');
    setLabelText(label, name);

    var total = 0;
    var countsOk = true;
    present.forEach(function (it) {
      if (it.dead) { return; }
      if (isNaN(it.count)) { countsOk = false; } else { total += it.count; }
    });
    var spans = label.querySelectorAll('.count');
    for (var s = 0; s < spans.length; s++) {
      if (!countsOk) {
        spans[s].parentNode.removeChild(spans[s]);
      } else {
        var wrapped = spans[s].textContent.trim().charAt(0) === '(';
        spans[s].textContent = wrapped ? '(' + total + ')' : String(total);
      }
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rg-lf-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Show options for ' + name);
    btn.innerHTML = CHEVRON;
    li.appendChild(btn);

    /* The real values sit in a tray under the group chip. */
    var tray = document.createElement('li');
    tray.className = 'rg-lf-tray';
    tray.id = id + '-tray';
    var trayList = document.createElement('ul');
    trayList.className = 'rg-lf-tray-list';
    trayList.setAttribute('role', 'list');
    tray.appendChild(trayList);
    present.forEach(function (it) {
      it.li.classList.add('rg-lf-sub');
      it.li.classList.toggle(OFF, it.dead);
      trayList.appendChild(it.li);
    });
    btn.setAttribute('aria-controls', tray.id);

    var rec = {
      key: ctx.id + '|' + name,
      li: li,
      tray: tray,
      input: input,
      label: label,
      btn: btn,
      items: present,
      inputs: present.map(function (it) { return it.input; }),
      open: false
    };
    groupOf.set(input, rec);
    toggleOf.set(btn, rec);
    return rec;
  }

  /* Checked = all values that can be ticked are ticked. Partly checked = some. */
  function refreshGroup(rec) {
    var usable = rec.inputs.filter(function (i) { return !i.disabled; });
    var on = usable.filter(function (i) { return i.checked; }).length;
    var all = usable.length > 0 && on === usable.length;
    var none = usable.length === 0;
    rec.input.disabled = none;
    rec.input.checked = all;
    rec.input.indeterminate = on > 0 && !all;
    rec.li.classList.toggle('facet-checkbox--disabled', none);
    rec.label.classList.toggle('disabled', none);
  }

  function syncTray(rec) {
    rec.tray.classList.toggle(OFF, !(rec.open && !rec.li.classList.contains(OFF)));
  }

  function setOpen(rec, open) {
    rec.open = open;
    rec.li.classList.toggle('rg-lf-open', open);
    rec.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    syncTray(rec);
  }

  function forWhomUnits(ctx) {
    var used = {};
    var units = [];
    var recs = [];
    var order = 0;
    var n = 0;
    cfg.forWhom.forEach(function (g) {
      var present = [];
      g.values.forEach(function (v) {
        var it = ctx.byKey[norm(v)];
        if (it && !used[it.k]) { used[it.k] = true; present.push(it); }
      });
      if (!present.length) { return; }
      if (g.values.length < 2) {
        units.push(plainUnit(present[0], order++));   /* one value: a plain chip */
        return;
      }
      var rec = buildGroup(ctx, g.name, present, n++);
      recs.push(rec);
      var usable = present.filter(function (it) { return !it.dead; });
      var total = 0;
      var ok = true;
      usable.forEach(function (it) { if (isNaN(it.count)) { ok = false; } else { total += it.count; } });
      units.push({
        els: [rec.li, rec.tray],
        inputs: rec.inputs,
        rec: rec,
        count: ok ? total : NaN,
        avail: usable.length > 0,
        pinned: false,
        late: false,
        order: order++,
        rank: Infinity
      });
    });
    /* Values that are in no group are plain chips, ranked by their count like the others. */
    ctx.items.forEach(function (it) {
      if (!used[it.k]) { used[it.k] = true; units.push(plainUnit(it, order++)); }
    });
    ctx.recs = recs;
    return units;
  }

  function onGroupChange(rec) {
    var on = rec.input.checked;
    if (memory[rec.key] === undefined) { memory[rec.key] = rec.open; }
    var changed = [];
    rec.inputs.forEach(function (i) {
      if (!i.disabled && i.checked !== on) { i.checked = on; changed.push(i); }
    });
    refreshGroup(rec);
    if (!changed.length) { return; }
    /* Same events as a real tick, so the theme applies the filter the usual way. */
    var last = changed[changed.length - 1];
    last.dispatchEvent(new Event('input', { bubbles: true }));
    last.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- the view of one list: which chips show, and "Show more (N)" ---------- */

  function refreshView(view) {
    var hidden = 0;
    var behind = false;
    var q = view.query ? norm(view.query) : '';
    var found = 0;
    view.units.forEach(function (u) {
      var base = u.avail && (u.pinned || u.rank < TOP);
      var picked = u.inputs.some(function (i) { return i.checked; });
      var on;
      if (q) {
        /* Searching: every choice whose name has the typed words, plus the ticked ones. */
        var hit = u.avail && typeof u.text === 'string' && u.text.indexOf(q) >= 0;
        if (hit) { found++; }
        on = u.avail && (hit || picked);
      } else {
        on = u.avail && (base || picked || view.expanded);
      }
      if (u.avail && !base) { behind = true; }
      if (u.avail && !on) { hidden++; }
      u.els[0].classList.toggle(OFF, !on);
      if (u.rec) { syncTray(u.rec); }
    });
    if (view.none) { view.none.classList.toggle(OFF, !(q && found === 0)); }
    if (!view.btn) { return; }
    view.btn.setAttribute('aria-expanded', view.expanded ? 'true' : 'false');
    view.btn.querySelector('.rg-lf-more-text').textContent =
      view.expanded ? view.lessText : view.moreText + ' (' + hidden + ')';
    view.wrap.classList.toggle(OFF, !!q || !behind || (!view.expanded && hidden === 0));
  }

  /* Product filter with many choices: a search box above the list. It has no name, so the
     theme's form never sends it; its own events stay away from the form. */
  function addSearch(ctx, view) {
    var box = document.createElement('div');
    box.className = 'rg-lf-search';
    var input = document.createElement('input');
    input.type = 'search';
    input.placeholder = 'Search products';
    input.setAttribute('aria-label', 'Search products');
    input.setAttribute('autocomplete', 'off');
    input.value = typeof memory[view.key + '|q'] === 'string' ? memory[view.key + '|q'] : '';
    box.appendChild(input);
    var none = document.createElement('p');
    none.className = 'rg-lf-none ' + OFF;
    none.textContent = 'No products match.';
    box.appendChild(none);
    ctx.list.parentNode.insertBefore(box, ctx.list);
    view.query = input.value;
    view.none = none;
    var onType = function (e) {
      e.stopPropagation();
      view.query = input.value;
      memory[view.key + '|q'] = input.value;
      refreshView(view);
    };
    input.addEventListener('input', onType);
    input.addEventListener('search', onType);
    input.addEventListener('change', function (e) { e.stopPropagation(); });
    input.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (e.key === 'Enter') { e.preventDefault(); }
    });
  }

  function finishList(ctx, units) {
    var ordered = rank(units);
    place(ctx.list, ordered);
    ordered.forEach(function (u) { if (u.tag) { addTag(u.els[0]); } });
    /* Anything we did not make a chip of stays out of sight. */
    ctx.items.forEach(function (it) {
      var inUnit = ordered.some(function (u) { return u.els.indexOf(it.li) >= 0 || (u.rec && u.rec.items.indexOf(it) >= 0); });
      if (!inUnit) { it.li.classList.add(OFF); }
    });

    var view = {
      ctx: ctx,
      units: ordered,
      key: ctx.id + '|more',
      expanded: false,
      btn: null,
      wrap: null
    };
    view.expanded = memory[view.key] === true;

    var holder = ctx.list.closest('.filter-attribute') || ctx.list.parentNode;
    var moreEl = holder.querySelector('.label-show-more');
    var lessEl = holder.querySelector('.label-show-less');
    view.moreText = (moreEl && moreEl.textContent.trim()) || 'Show more';
    view.lessText = (lessEl && lessEl.textContent.trim()) || 'Show less';

    var wrap = document.createElement('div');
    wrap.className = 'rg-lf-more-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rg-lf-more';
    btn.innerHTML = '<span class="rg-lf-more-text"></span>';
    wrap.appendChild(btn);
    ctx.list.parentNode.insertBefore(wrap, ctx.list.nextSibling);
    view.btn = btn;
    view.wrap = wrap;
    btn.addEventListener('click', function () {
      view.expanded = !view.expanded;
      memory[view.key] = view.expanded;
      refreshView(view);
    });

    (ctx.recs || []).forEach(function (rec) {
      refreshGroup(rec);
      var saved = memory[rec.key];
      setOpen(rec, typeof saved === 'boolean' ? saved : rec.input.indeterminate);
    });
    var choices = ordered.filter(function (u) { return u.avail; }).length;
    if (ctx.key === 'product' && choices >= SEARCH_FROM) { addSearch(ctx, view); }

    groupsOf.set(ctx.list, ctx.recs || []);
    viewOf.set(ctx.list, view);
    refreshView(view);
  }

  /* ---------- events (one set per tidied list) ---------- */

  function attach(list) {
    list.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest('.rg-lf-toggle') : null;
      var g = btn && list.contains(btn) ? toggleOf.get(btn) : null;
      if (g) {
        memory[g.key] = !g.open;
        setOpen(g, !g.open);
      }
    });

    /* The group checkbox is ours. Keep its own "input" event away from the theme form. */
    list.addEventListener('input', function (e) {
      if (groupOf.has(e.target)) { e.stopPropagation(); }
    });

    list.addEventListener('change', function (e) {
      var rec = groupOf.get(e.target);
      if (rec) {
        e.stopPropagation();
        onGroupChange(rec);
        return;
      }
      (groupsOf.get(list) || []).forEach(refreshGroup);
      var view = viewOf.get(list);
      if (view) { refreshView(view); }   /* a ticked chip never hides */
      runRules();
    });
  }

  /* ---------- run ---------- */

  function tidyList(list) {
    var ok = false;
    try {
      var first = list.querySelector('input[type="checkbox"]');
      if (first && !list.closest('.horizontal-filter-form')) {
        var name = first.getAttribute('name') || '';
        var key = cfg.nameToKey[name] || '';
        var ctx = readList(list);
        ctx.key = key || 'other';
        ctx.layout = layoutOf(list);
        ctx.id = ctx.layout + '|' + name;
        if (ctx.items.length) {
          var units;
          if (key === 'occasion') { units = occasionUnits(ctx); }
          else if (key === 'for_whom') { units = forWhomUnits(ctx); }
          else if (key === 'style') { units = plainUnits(ctx, cfg.style); }
          else { units = plainUnits(ctx); }
          /* Colour swatches keep the theme's own look. */
          if (list.querySelector('.facet-color')) { list.classList.add('rg-lf-color'); }
          finishList(ctx, units);
          ok = true;
        }
      }
    } catch (err) {
      ok = false;
    }
    /* "1" = tidied. Anything else just shows the list as the theme made it. */
    list.setAttribute(TIDY, ok ? '1' : 'skip');
    if (ok) { attach(list); }
  }

  function tidyAll() {
    var all = document.querySelectorAll(FORMS + ' .facets__list');
    var lists = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].hasAttribute(TIDY)) { lists.push(all[i]); }
    }
    lists.forEach(tidyList);
  }

  /* ---------- sections: hide / show, + / - toggle ---------- */

  function sectionKey(js) {
    var input = js.querySelector('input[name]');
    return layoutOf(js) + '|sec|' + (input ? input.getAttribute('name') : js.getAttribute('data-index'));
  }

  function applyOpen(js, open) {
    var d = js.querySelector('details');
    if (!d) { return; }
    js.setAttribute('data-rg-open', open ? '1' : '0');
    if (open) { d.setAttribute('open', ''); d.classList.add('detail-open'); }
    else { d.removeAttribute('open'); d.classList.remove('detail-open'); }
    var s = d.querySelector('summary');
    if (s) { s.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  }

  /* Type, Print size, Set: only for one kind of product. null = no Product filter in this form. */
  function oneKindHere(form) {
    var kinds = form.querySelectorAll('input[name=' + quote(cfg.productParam) + ']');
    if (!kinds.length) { return null; }
    /* Count different products, not boxes: the theme can draw the same list twice. */
    var picked = {};
    var available = {};
    for (var k = 0; k < kinds.length; k++) {
      if (kinds[k].checked) { picked[norm(kinds[k].value)] = true; }
      if (!kinds[k].disabled) { available[norm(kinds[k].value)] = true; }
    }
    var nPicked = Object.keys(picked).length;
    var nAvailable = Object.keys(available).length;
    return nPicked === 1 || (nPicked === 0 && nAvailable === 1);
  }

  function applyRules() {
    var forms = document.querySelectorAll(FORMS);
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      var kind = oneKindHere(form);
      var sections = form.querySelectorAll('.js-filter');
      var seen = 0;
      for (var s = 0; s < sections.length; s++) {
        var js = sections[s];
        /* Real filter boxes only: a group chip's own box has no name. */
        var inputs = js.querySelectorAll('.facets__list input[type="checkbox"][name]');
        var hide = false;
        if (inputs.length) {
          var picked = false;
          var choices = {};
          var n = 0;
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].checked) { picked = true; }
            if (!inputs[i].disabled) {
              var k = norm(inputs[i].value);
              if (!choices[k]) { choices[k] = true; n++; }
            }
          }
          var fname = inputs[0].getAttribute('name');
          var isKind = cfg.kindParams.indexOf(fname) >= 0;
          /* A ticked filter is never hidden. */
          if (!picked) {
            if (n <= 1) { hide = true; }                          /* one choice left: nothing to choose */
            if (isKind && kind === false) { hide = true; }        /* Type, Print size, Set on a mixed page */
          }
          /* Occasion on an occasion page, For whom on a for-whom page: always hidden.
             A pick from an old link still shows in "Your picks", with its x. */
          if (cfg.hideHere && fname === cfg.hideHere) { hide = true; }
          if (isKind) { js.setAttribute('data-rg-kind', hide ? 'hide' : 'show'); }
        }
        js.classList.toggle(OFF, hide);
        if (!hide) {
          var key = sectionKey(js);
          if (typeof memory[key] !== 'boolean') { memory[key] = seen < OPEN_FIRST; }
          applyOpen(js, memory[key]);
          seen++;
        }
      }
    }
  }

  function runRules() {
    try { applyRules(); } catch (err) {
      var marked = document.querySelectorAll('.js-filter');
      for (var i = 0; i < marked.length; i++) { marked[i].classList.remove(OFF); }
      root.setAttribute('data-rg-kind', 'off');
    }
  }

  /* Click on a section title: our own + / - toggle (the theme's own is switched off for these). */
  function onSummaryClick(e) {
    if (root.getAttribute('data-rg-lf') !== 'on') { return; }
    var t = e.target;
    var sum = t && t.closest ? t.closest('summary') : null;
    var js = sum ? sum.closest('.js-filter') : null;
    if (!js || !js.closest(FORMS) || !js.hasAttribute('data-rg-open')) { return; }
    e.preventDefault();
    e.stopPropagation();
    var open = js.getAttribute('data-rg-open') !== '1';
    memory[sectionKey(js)] = open;
    applyOpen(js, open);
  }

  /* ---------- phone drawer: "Show N products" ---------- */

  function resultCount() {
    var el = document.querySelector('.collection-count');
    var m = el ? /\d[\d,]*/.exec(el.textContent) : null;
    if (!m) {
      /* This theme: "You've viewed 12 of 47 results". The last number is the total. */
      var c = document.querySelector('.counting_product');
      var all = c ? c.textContent.match(/\d[\d,]*/g) : null;
      if (all && all.length) { m = [all[all.length - 1]]; }
    }
    if (!m) {
      var ap = document.querySelector('.js-filter-apply');
      m = ap ? /\d[\d,]*/.exec(ap.textContent) : null;
    }
    return m ? parseInt(m[0].replace(/,/g, ''), 10) : NaN;
  }

  function updateApply() {
    var n = resultCount();
    var label = isNaN(n) ? 'Show products' : (n === 0 ? 'No products found' : 'Show ' + n + (n === 1 ? ' product' : ' products'));
    var els = document.querySelectorAll('.js-filter-apply');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-rg-label') !== label) {
        els[i].setAttribute('data-rg-label', label);
        els[i].setAttribute('aria-label', label);
      }
      if (!els[i].hasAttribute('role')) { els[i].setAttribute('role', 'button'); }
    }
  }

  /* ---------- Your picks: the theme's own active filters block, shown above the filters on desktop ---------- */

  var picksHome = null;   /* marks where the block sits in the theme's page */

  function placePicks() {
    var block = document.querySelector('.facets-filters-active');
    var side = document.querySelector('#CollectionSidebar facet-filters-form');
    if (!block || !side || !side.parentNode) { return; }
    var wide = window.matchMedia('(min-width: 1025px)').matches;
    if (wide) {
      if (block.nextElementSibling !== side) {
        if (!picksHome) {
          picksHome = document.createComment('rg-picks');
          block.parentNode.insertBefore(picksHome, block);
        }
        side.parentNode.insertBefore(block, side);
      }
      block.classList.add('rg-lf-picks-side');
    } else if (picksHome && picksHome.parentNode) {
      picksHome.parentNode.insertBefore(block, picksHome.nextSibling);
      block.classList.remove('rg-lf-picks-side');
    }
  }

  /* ---------- "Filter by" header with "Clear all" (desktop sidebar) ---------- */

  function clearLink() {
    return document.querySelector('.facets-filters-active .facet-clear-all a[href]');
  }

  function hasPicks() {
    return !!document.querySelector('.facets-filters-active .facet-remove a[href]') || /[?&]filter\./.test(location.search);
  }

  function placeHead() {
    var side = document.querySelector('#CollectionSidebar facet-filters-form');
    var holder = side ? side.parentNode : null;
    if (!holder) { return; }
    var head = holder.querySelector(':scope > .rg-lf-head');
    if (!head) {
      head = document.createElement('div');
      head.className = 'rg-lf-head';
      var title = document.createElement('h2');
      title.className = 'rg-lf-head-title';
      title.textContent = 'Filter by';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rg-lf-clear';
      btn.textContent = 'Clear all';
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') { return; }
        var link = clearLink();
        if (link) { link.click(); return; }   /* the theme's own Clear all (no page reload) */
        var sort = new URLSearchParams(location.search).get('sort_by');
        location.href = location.pathname + (sort ? '?sort_by=' + encodeURIComponent(sort) : '');
      });
      head.appendChild(title);
      head.appendChild(btn);
      holder.insertBefore(head, holder.firstChild);
    }
    var clear = head.querySelector('.rg-lf-clear');
    var on = hasPicks();
    if (clear.getAttribute('aria-disabled') !== String(!on)) { clear.setAttribute('aria-disabled', String(!on)); }
  }

  /* ---------- the theme's refresh after a pick: match sections by filter name, not position ----------
     The theme puts the new HTML of each filter into the section with the same position (data-index).
     When Shopify leaves out a filter (no choices left), every later section got the wrong content:
     one filter showed twice and another went missing (also on the live theme). Before the theme's own
     renderFilters runs, give each new section the position of the live section with the same filter. */

  function filterKey(js) {
    var input = js.querySelector('input[name]');
    return input ? input.getAttribute('name').replace(/\.(gte|lte)$/, '') : '';
  }

  function matchByName(htmlRender) {
    ['FacetFiltersForm', 'FacetFiltersFormDrawer'].forEach(function (formId) {
      var live = document.querySelectorAll('#' + formId + ' .js-filter');
      var fresh = htmlRender.querySelectorAll('#' + formId + ' .js-filter');
      if (!live.length || !fresh.length) { return; }
      var index = {};
      for (var i = 0; i < live.length; i++) {
        var k = filterKey(live[i]);
        if (k && index[k] === undefined) { index[k] = live[i].getAttribute('data-index'); }
      }
      var sent = {};
      for (var j = 0; j < fresh.length; j++) {
        var key = filterKey(fresh[j]);
        if (!key) { continue; }
        sent[key] = true;
        if (index[key] !== undefined) {
          fresh[j].setAttribute('data-index', index[key]);
        } else if (fresh[j].parentNode) {
          fresh[j].parentNode.removeChild(fresh[j]);   /* a filter the page does not have yet: skip it */
        }
      }
      /* Live sections whose filter Shopify left out: hide them until it comes back. */
      for (var m = 0; m < live.length; m++) {
        var lk = filterKey(live[m]);
        if (lk) { live[m].style.display = sent[lk] ? '' : 'none'; }
      }
    });
  }

  function fixThemeRender() {
    if (!window.customElements || !customElements.whenDefined) { return; }
    customElements.whenDefined('facet-filters-form').then(function (F) {
      if (!F || typeof F.renderFilters !== 'function' || F.renderFilters.rgByName) { return; }
      var original = F.renderFilters;
      var byName = function (htmlRender, event) {
        try { if (htmlRender && htmlRender.querySelectorAll) { matchByName(htmlRender); } } catch (err) { /* the theme's own way */ }
        return original.call(this, htmlRender, event);
      };
      byName.rgByName = true;
      F.renderFilters = byName;
    });
  }

  function runAll() {
    tidyAll();
    runRules();
    try { placeHead(); } catch (err) { /* no header: the filters still work */ }
    try { placePicks(); } catch (err) { /* the block stays where the theme put it */ }
    try { updateApply(); } catch (err) { /* the theme's own button text stays */ }
  }

  function start() {
    try { fixThemeRender(); } catch (err) { /* the theme keeps its own way */ }
    runAll();
    document.addEventListener('click', onSummaryClick, true);
    var wide = window.matchMedia('(min-width: 1025px)');
    if (wide.addEventListener) { wide.addEventListener('change', function () { try { placePicks(); } catch (err) { /* ignore */ } }); }
    /* The theme replaces filter HTML after every change (AJAX), and moves the
       drawer into <body>. Watch for new nodes and tidy any new list. */
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          runAll();
          observer.takeRecords();   /* ignore the changes we just made */
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();